import { Datatype } from './datatype';
import { IDatabase } from './i/idatabase';

export class Database implements IDatabase {
    id: number;
    name: string;
    arrayId: number;
    binaryId: number;
    charLength: number;
    code: string;
    complex: string;
    createTarget: string;
    deNormalize: string;
    imageUrl: string;
    defaultId: number;
    defaultNumericId: number;
    designName: string;
    flavourOf: number;
    hasDBFun: string;
    hasNativeSequence: string;
    hasParentChild: string;
    hasUDF: string;
    isLicensed: number;
    mapId: number;
    nativeId: number;
    objectId: number;
    stringId: number;
    textFile: string;
    uiId: number;

    datatype: Array<Datatype>;

    constructor() {
        this.id = -1;
        this.datatype = new Array<Datatype>();
    }
}
